module.exports = __webpack_public_path__ + "img/direction-communities.1d8ada41.svg";